import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import usePreloadMediaImages from '../../utils/hooks/usePreloadMediaImages';
import ModelCardUI from './ModelCardUI';
const ModelCard = ({ model, hasShadow, inventoryStatus, inventoryStatusPosition, includeCalculatorParams, nextStepUrl, hasIntegratedFilters, }) => {
    // pre-load hover state thumbnail image
    const { secondaryThumbnail } = model;
    usePreloadMediaImages(secondaryThumbnail === null || secondaryThumbnail === void 0 ? void 0 : secondaryThumbnail.src);
    return (_jsx(ModelCardUI, { hasShadow: hasShadow, model: model, inventoryStatus: inventoryStatus, inventoryStatusPosition: inventoryStatusPosition, includeCalculatorParams: includeCalculatorParams, nextStepUrl: nextStepUrl, hasIntegratedFilters: hasIntegratedFilters }));
};
export default ModelCard;
